import {cssTransition} from 'react-toastify';

export const Slide = cssTransition({
  // NOTE: These CSS classes are defined within the react-toastify package files.
  enter: 'Toastify__slide-enter',
  exit: 'Toastify__slide-exit',
  duration: 300,
  appendPosition: true
});
